/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

'use strict';

module.exports = require('react-transition-group/TransitionGroup');



//////////////////
// WEBPACK FOOTER
// ./~/material-ui/~/react-addons-transition-group/index.js
// module id = 165
// module chunks = 0 1